/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Radio, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Typography, CircularProgress, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SnackBar from '../../../components/snackbar/snackbar';
import DeleteAlert from '../../../components/modal/DeleteModal';
import adminServices from '../../../services/adminServices';
import CreateHearAboutUsModal from './SettingCreatePage'

const DataTable = ({ title, tableType, details, onGetAllDetails,subCategory}) => {    
    const [entries, setEntries] = useState([]);
    const [snackbarTitle, setSnackbarTitle] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [editModuleOpen, setEditModuleOpen] = useState(false);
    const [moduleopen, setModuleopen] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [tagList, setTagList] = useState([]);
    const [chapterList, setChapterList] = useState([]);
    const [questionTypeList, setQuestionTypeList] = useState([]);
    const [assessmentTypeList, setAssessmentTypeList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [subCategoryList, setSubCategoryList] = useState([]);
    const [chapterType, setchapterType] = useState('English');

    useEffect(() => {
        setEntries(details);
    }, [details]);
    const handleEditOpen = (entry) => {
        setCurrentEntry(entry);
        setEditModuleOpen(true);
    };
    const { t } = useTranslation('translation');
    const getCategory = async () => {
        const result = await adminServices.getCategoryLists();
        if (result.ok) setCategoryList(result.data);
    };
    const getList = async () => {
        const result = await adminServices.getTagLists();
        if (result.ok) setTagList(result.data);
    };

    const getQuestionTypeList = async () => {
        try {
            const result = await adminServices.getQuestionTypeDropdown();
            if (result && result.ok) {
                const list = result.data?.data || result.data || [];
                setQuestionTypeList(list);
            }
        } catch (error) {
            console.error('Question Type dropdown API not ready:', error);
            setQuestionTypeList([]);
        }
    };

    const getAssessmentTypeList = async () => {
        try {
            const result = await adminServices.getAssessmentTypeDropdown();
            if (result && result.ok) {
                const list = result.data?.data || result.data || [];
                setAssessmentTypeList(list);
            }
        } catch (error) {
            console.error('Assessment Type dropdown API not ready:', error);
            setAssessmentTypeList([]);
        }
    };

    const getChapterListForTable = async () => {
        try {
            const result = await adminServices.getSuperAdminChapters();
            if (result?.data?.success) {
                setChapterList(result.data.data);
            }
        } catch (error) {
            console.error('Chapter fetch error:', error);
            setChapterList([]);
        }
    };
    const getSubCategoryList = () => {
        setSubCategoryList(subCategory || []);
    };

    useEffect(() => {
        setSubCategoryList(subCategory || []);
    }, [subCategory]);

    const refreshCurrentTable = async () => {
        setTableLoading(true);
        try {
            switch (tableType) {
                case 'category_page': await getCategory(); break;
                case 'tag_page': await getList(); break;
                case 'question_type': await getQuestionTypeList(); break;
                case 'assessment_type': await getAssessmentTypeList(); break;
                case 'chapter_page': await getChapterListForTable(); break;
                case 'sub_category_page': await getSubCategoryList(); break;
                default: break;
            }
        } finally {
            setTableLoading(false);
        }
    };
useEffect(() => {
    refreshCurrentTable();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [tableType]);
const confirmDelete = async () => {
    let result;

    if (tableType === 'sub_category_page') {
        result = await adminServices.deleteSubCategoryValue(deleteId);
    } else if (tableType === 'tag_page') {
        result = await adminServices.deleteTagValue(deleteId);
    } else if (tableType === 'chapter_page') {
        result = await adminServices.deleteChapter(deleteId);
    } else if (tableType === 'question_type') {
        result = await adminServices.deleteQuestionType(deleteId);
    } else if (tableType === 'assessment_type') {
        result = await adminServices.deleteAssessmentType(deleteId);
    } else if (tableType === 'category_page') {
        result = await adminServices.deleteCategoryValue(deleteId);
    } else {
        result = await adminServices.deleteDropDownValue(tableType, deleteId);
    }
    setDeleteOpen(false);
    if (!result) return;
    const success = result.ok || (result.data && result.data.message);
    if (success) {
        switch (tableType) {
            case 'category_page':
                setCategoryList(prev => prev.filter(item => item.id !== deleteId));
                break;
            case 'tag_page':
                setTagList(prev => prev.filter(item => item.id !== deleteId));
                break;
            case 'chapter_page':
                setChapterList(prev => prev.filter(item => item.id !== deleteId));
                break;
            case 'question_type':
                setQuestionTypeList(prev => prev.filter(item => item.id !== deleteId));
                break;
            case 'assessment_type':
                setAssessmentTypeList(prev => prev.filter(item => item.id !== deleteId));
                break;
            default:
                setEntries(prev => prev.filter(item => item.id !== deleteId));
                break;
        }
        setSnackbarTitle(result.data?.message || t("Deleted successfully!"));
        setOpenSnackbar(true);
        await refreshCurrentTable();
            if (onGetAllDetails) onGetAllDetails();
        }
    };

    const handleCreatOpen = () => setModuleopen(true);
    const handleCreateClose = async () => {
        setModuleopen(false);
        await refreshCurrentTable();
        if (onGetAllDetails) onGetAllDetails();
    };
    const handleEditClose = async () => {
        setEditModuleOpen(false);
        await refreshCurrentTable();
        if (onGetAllDetails) onGetAllDetails();
    };
    const renderTableRows = () => {
        if (tableLoading) {
            return (
                <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 6 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <CircularProgress size={32} />
                            <Typography variant="body2" color="text.secondary">Loading...</Typography>
                        </Box>
                    </TableCell>
                </TableRow>
            );
        }
        if (tableType === 'category_page') {
            return categoryList?.map((category) => (
                <TableRow key={category.id}>
                    <TableCell>{category.id}</TableCell>
                    <TableCell>{category.code}</TableCell>
                    <TableCell>{category.description}</TableCell>
                    <TableCell>
                        <Button onClick={() => handleEditOpen(category)}>
                            <EditIcon />
                        </Button>
                        <Button onClick={() => { setDeleteId(category.id); setDeleteOpen(true); }}>
                            <DeleteIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ));
        }

        if (tableType === 'tag_page') {
            return tagList?.map((tag) => (
                <TableRow key={tag.id}>
                    <TableCell>{tag.id}</TableCell>
                    <TableCell>{tag.code}</TableCell>
                    <TableCell>{tag.description}</TableCell>
                    <TableCell>
                        <Button onClick={() => handleEditOpen(tag)}>
                            <EditIcon />
                        </Button>
                        <Button onClick={() => { setDeleteId(tag.id); setDeleteOpen(true); }}>
                            <DeleteIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ));
        }

        if (tableType === 'chapter_page') {
            return chapterList?.map((chapter) => (
                <TableRow key={chapter.id}>
                    <TableCell>{chapter.id}</TableCell>
                     <TableCell>{chapter.code}</TableCell>
                     <TableCell>{chapter.description}</TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>
                        <Button onClick={() => handleEditOpen(chapter)}>
                            <EditIcon />
                        </Button>
                        <Button onClick={() => { setDeleteId(chapter.id); setDeleteOpen(true); }}>
                            <DeleteIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ));
        }
        if (tableType === 'sub_category_page') {
            return subCategoryList?.map((entry) => (
                <TableRow key={entry.id}>
                    <TableCell>{entry.id}</TableCell>
                    <TableCell>{entry.code}</TableCell>
                    <TableCell>{entry.description}</TableCell>
                    <TableCell>
                        <Button onClick={() => handleEditOpen(entry)}><EditIcon /></Button>
                        <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}><DeleteIcon /></Button>
                    </TableCell>
                </TableRow>
            ));
        }
        if (tableType === 'question_type') {
            const data = questionTypeList;
            return data?.map((item) => (
                <TableRow key={item.id}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.code}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!item.is_active}
                                    disabled
                                    color="success"
                                    sx={{
                                        '&.Mui-disabled': {
                                            color: item.is_active ? 'success.main' : 'text.disabled',
                                        },
                                    }}
                                />
                            }
                            label={
                                <Typography
                                    variant="body2"
                                    color={item.is_active ? 'success.main' : 'text.secondary'}
                                >
                                    {item.is_active ? 'Active' : 'Inactive'}
                                </Typography>
                            }
                        />
                    </TableCell>
                    <TableCell align="right" sx={{ width: 120, pr: 3 }}>
                        <Button onClick={() => handleEditOpen(item)}>
                            <EditIcon />
                        </Button>
                        <Button onClick={() => { setDeleteId(item.id); setDeleteOpen(true); }}>
                            <DeleteIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ));
        }

        if (tableType === 'assessment_type') {
            return assessmentTypeList?.map((item) => (
                <TableRow key={item.id}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.code}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!item.is_active}
                                    disabled
                                    color="success"
                                    sx={{
                                        '&.Mui-disabled': {
                                            color: item.is_active ? 'success.main' : 'text.disabled',
                                        },
                                    }}
                                />
                            }
                            label={
                                <Typography
                                    variant="body2"
                                    color={item.is_active ? 'success.main' : 'text.secondary'}
                                >
                                    {item.is_active ? 'Active' : 'Inactive'}
                                </Typography>
                            }
                        />
                    </TableCell>
                    <TableCell align="right" sx={{ width: 120, pr: 3 }}>
                        <Button onClick={() => handleEditOpen(item)}>
                            <EditIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ));
        }

        if (tableType === 'login_page') {
            return entries?.map((entry) => (
                <TableRow key={entry.id}>
                    <TableCell>{entry.id}</TableCell>
                    <TableCell>{entry.description}</TableCell>
                    <TableCell>
                        {entry.thumbImageUrl && (
                            <img
                                src={entry.thumbImageUrl}
                                alt="Login"
                                style={{ width: '120px', height: 'auto' }}
                            />
                        )}
                    </TableCell>
                    <TableCell>
                        <Button>
                            <EditIcon />
                        </Button>
                        <Button >
                            <DeleteIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ));
        }

        // console.log(entries, "entries222222222");
        return entries?.map((entry) => (
            <TableRow key={entry.id}>
                {tableType === 'offer_announcement' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>{entry.selectedCourse}</TableCell>
                        <TableCell>{entry.title}</TableCell>
                        <TableCell>{entry.rating}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'sub_category_page' &&
                    (
                        <>
                            <TableCell>{entry.id}</TableCell>
                            <TableCell>{entry.code}</TableCell>
                            <TableCell>{entry.description}</TableCell>
                            <TableCell>
                                <Button onClick={() => handleEditOpen(entry)}>
                                    <EditIcon />
                                </Button>
                                <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>
                                    <DeleteIcon />
                                </Button>
                            </TableCell>
                        </>
                    )
                }



                {tableType === 'hear_about_us' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'user_greeting' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>{entry.scenario}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'career_goal' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'job' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'education' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'work_experience' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'current_role' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'currency' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.code}</TableCell>
                        <TableCell>
                            <Radio checked={entry.isActive} color={entry.isActive ? 'success' : 'error'} />
                        </TableCell>
                        <TableCell>{entry.description}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'static_banner_message' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'offer_page' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.title}</TableCell>
                        <TableCell>{entry.time ? entry.time : '-'}</TableCell>
                        <TableCell>{entry.course ? entry.selectedCourse : '-'}</TableCell>
                        <TableCell>{entry.description}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'login_page' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.description}</TableCell>
                        <TableCell>{entry.Image}</TableCell>

                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )}
                {tableType === 'email_template' &&
                    (
                        <>
                            <TableCell>{entry.id}</TableCell>
                            <TableCell>{entry.code}</TableCell>
                            <TableCell>{entry.description}</TableCell>
                            <TableCell>
                                <Button onClick={() => handleEditOpen(entry)}>
                                    <EditIcon />
                                </Button>
                                <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>
                                    <DeleteIcon />
                                </Button>
                            </TableCell>
                        </>
                    )
                }
                {/* {tableType === 'lerners_viewing' && (
                    <>
                        <TableCell>{entry.id}</TableCell>
                        <TableCell>{entry.value}</TableCell>
                        <TableCell>{entry.description}</TableCell>
                        <TableCell>{entry.discount}</TableCell>
                        <TableCell>{entry.rating}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEditOpen(entry)}>
                                <EditIcon />
                            </Button>
                            <Button onClick={() => { setDeleteId(entry.id); setDeleteOpen(true); }}>  <DeleteIcon /></Button>
                        </TableCell>
                    </>
                )} */}
            </TableRow>

        ))
    };
    return (
        <div>
            <Button style={{ marginLeft: '15px', height: '40px' }}
                id="createQuestionButton"
                variant="contained"
                color="primary"
                onClick={handleCreatOpen}
            >
                Create {title}
            </Button>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {tableType === 'offer_announcement' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>SelectedCourse</TableCell>
                                    <TableCell>Title</TableCell>
                                    <TableCell> Rating</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'hear_about_us' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'user_greeting' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Scenario</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {/* {tableType === 'lerners_viewing' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Discount</TableCell>
                                    <TableCell>Rating</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )} */}
                            {tableType === 'career_goal' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Goal</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'job' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Job Title</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'education' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'work_experience' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'current_role' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'currency' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Code</TableCell>
                                    <TableCell>Is Active</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'static_banner_message' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'offer_page' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Title</TableCell>
                                    <TableCell>Duration</TableCell>
                                    <TableCell>course</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'category_page' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Category Code</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'sub_category_page' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Sub Category Code</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}

                            {tableType === 'login_page' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Image</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'email_template' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Code</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}

                            {tableType === 'tag_page' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Code</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'chapter_page' && (
                                <>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Code</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'question_type' && (
                                <>
                                    <TableCell sx={{ width: 80 }}>ID</TableCell>
                                    <TableCell sx={{ width: 200 }}>Question Type CODE</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell sx={{ width: 120 }}>Status</TableCell>
                                    <TableCell align="right" sx={{ pr: 2 }}>Actions</TableCell>
                                </>
                            )}
                            {tableType === 'assessment_type' && (
                                <>
                                    <TableCell sx={{ width: 80 }}>ID</TableCell>
                                    <TableCell sx={{ width: 200 }}>Assessment Type CODE</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell sx={{ width: 120 }}>Status</TableCell>
                                    <TableCell align="right" sx={{ pr: 2 }}>Actions</TableCell>
                                </>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderTableRows()}
                    </TableBody>
                </Table>

            </TableContainer>

            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={
                    tableType === 'category_page' ? categoryList.length :
                     tableType === 'sub_category_page' ? subCategoryList.length :
                        tableType === 'tag_page' ? tagList.length :
                            tableType === 'chapter_page' ? chapterList.length :
                                tableType === 'question_type' ? questionTypeList.length :
                                    tableType === 'assessment_type' ? assessmentTypeList.length :
                                        entries.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(event, newPage) => setPage(newPage)}
                onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                }}
            />
            {moduleopen && (
                <CreateHearAboutUsModal
                    open={moduleopen}
                    onClose={handleCreateClose}
                    refresh={tableType}
                    subCategory={subCategory}
                    questionTypeList={questionTypeList}
                    assessmentTypeList={assessmentTypeList}
                    onSuccess={(msg) => { setSnackbarTitle(msg); setOpenSnackbar(true); }}
                />

            )}
            {editModuleOpen &&
                <CreateHearAboutUsModal
                    open={editModuleOpen}
                    onClose={handleEditClose}
                    refresh={tableType}
                    initialData={currentEntry}
                    {...(true && { isEdit: true })}
                    subCategory={subCategory}
                    questionTypeList={questionTypeList}
                    assessmentTypeList={assessmentTypeList}
                    onSuccess={(msg) => { setSnackbarTitle(msg); setOpenSnackbar(true); }}
                />
            }

            <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
            <DeleteAlert
                open={deleteOpen}
                title="Are you sure you want to delete this entry?"
                confirm={confirmDelete}
                close={() => setDeleteOpen(false)}
            />

        </div>
    );
};



export default DataTable;